import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

import { DataTablesModule } from 'angular-datatables';
import { ChartsModule } from 'ng2-charts';
import { AgmCoreModule } from '@agm/core';

// Dew Prebuild Modules and Components
// import { ManageUsersComponent } from '../manage-users/manage-users.component';
// import { ManageRolesComponent } from '../manage-roles/manage-roles.component';
// import { ManageEntitiesComponent } from '../manage-entities/manage-entities.component';
// import { ManageOperationsComponent } from '../manage-operations/manage-operations.component';
// import { ManageCodetablesComponent } from '../manage-codetables/manage-codetables.component';
// import { ManageDocumentsComponent } from '../manage-documents/manage-documentss.component';

import { MaterialModule } from '../material.module';
import { FileInput } from './file-input/file-input';

import { DeleteConfirmDialogComponent } from './delete-confirm-dialog/delete-confirm-dialog.component';
import { DewAlertDialogComponent } from './dew-alert-dialog/dew-alert-dialog.component';
import { DewConfirmDialogComponent } from './dew-confirm-dialog/dew-confirm-dialog.component';

import { DataTableFilterComponent } from './grids/datatable-filter.component';
import { NoitemComponent } from './noitem/noitem.component';
import { ErrorComponent } from './error/error.component';
import { ForgotComponent } from './forgot/forgot.component';
import { NotFoundComponent } from './not-found/not-found.component';
import {
  MyProfileComponent,
  ChangePasswordDialog,
} from './my-profile/my-profile.component';

import { ClipboardModule } from 'ngx-clipboard';

import {
  AddApplicationUserDialog,
  EditApplicationUserDialog,
  UserDetailsComponent,
  AddApplicationUserRolesDialog,
} from './user-details/user-details.component';
import {
  EditApplicationEntityDialog,
  AddApplicationEntityDialog,
} from './entities-details/entities-details.component';
import {
  AddApplicationOperationsDialog,
  EditApplicationOperationsDialog,
} from './operations-details/operations-details.component';
import {
  AddApplicationRoleDialog,
  EditApplicationRoleDialog,
  RoleDetailsComponent,
  RoleAddEntityOperationDialog,
} from './role-details/role-details.component';
import {
  CodetablesDetailsComponent,
  AddCodeTableDialog,
  EditCodeTableDialog,
} from './codetables-details/codetables-details.component';
import {
  AddDocumentDialog,
  EditDocumentDialog,
  DocumentDetailsComponent,
} from './document-details/document-details.component';

import { CodeTablesGridView } from './codetables-details/codetables-grid-view.component';

import { UserListComponent } from './user-list/user-list.component';
import { RoleListComponent } from './role-list/role-list.component';
import {
  CodetablesListComponent,
  AddCodeTableHeaderDialog,
} from './codetables-list/codetables-list.component';
import { DocumentListComponent } from './document-list/document-list.component';

import { gridviewRoles } from './role-details/grid-view-roles.component';
import { dewMatPager } from './dew-mat-pager/dew-mat-pager';
import { MustMatchDirective } from './must-match/must-match.directive';
import { from } from 'rxjs';
import { DewDataTableComponent } from './grids/dew-datatable/dew-datatable.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { UsernameUniqueDirective } from './unique-check/username-unique.directive';
import { EmailUniqueDirective } from './unique-check/email-unique.directive';
import { RegisterComponent } from './register/register.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { DisablePasteDirective } from './disable-copy-paste/disable-paste.directive';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { dewVideoPlayer } from './dew-video-player/dew-video-player';
import { HasPermission } from 'src/authentication/core/has.permission';
import { CommonModule } from '@angular/common';
import {
  AddApplicationRoleAndTaskDialog,
  EditApplicationRoleAndTaskDialog,
  RoleAndTaskAddEntityOperationDialog,
} from './role-and-task-details/role-and-task-details.component';
import { SubDomainUniqueDirective } from './unique-check/subdomain-unique.directive';

@NgModule({
  declarations: [
    DataTableFilterComponent,
    //Pre-build shared Components
    UserDetailsComponent,
    UserListComponent,
    RoleListComponent,
    RoleDetailsComponent,
    CodetablesDetailsComponent,
    CodetablesListComponent,
    DocumentDetailsComponent,
    DocumentListComponent,
    NoitemComponent,
    NotFoundComponent,
    MyProfileComponent,
    ChangePasswordDialog,
    ErrorComponent,
    ForgotComponent,
    RegisterComponent,
    EditApplicationUserDialog,
    AddApplicationUserDialog,
    AddApplicationUserRolesDialog,
    EditApplicationEntityDialog,
    AddApplicationEntityDialog,
    EditApplicationOperationsDialog,
    AddApplicationOperationsDialog,
    DeleteConfirmDialogComponent,
    DewConfirmDialogComponent,
    DewAlertDialogComponent,
    AddApplicationRoleDialog,
    RoleAddEntityOperationDialog,
    EditApplicationRoleDialog,
    AddCodeTableDialog,
    EditCodeTableDialog,
    AddCodeTableHeaderDialog,
    AddDocumentDialog,
    EditDocumentDialog,
    FileInput,
    gridviewRoles,
    CodeTablesGridView,
    //Pre-build Pages
    dewMatPager,
    MustMatchDirective,
    DisablePasteDirective,
    UsernameUniqueDirective,
    EmailUniqueDirective,
    SubDomainUniqueDirective,
    HasPermission,
    DewDataTableComponent,
    ForbiddenComponent,
    dewVideoPlayer,
    AddApplicationRoleAndTaskDialog,
    EditApplicationRoleAndTaskDialog,
    RoleAndTaskAddEntityOperationDialog,
  ],
  imports: [
    FormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    DataTablesModule,
    ChartsModule,
    MaterialModule,
    AgmCoreModule.forRoot({
      apiKey: 'Replace Me',
    }),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    PdfViewerModule,
    CarouselModule,
    ClipboardModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    CommonModule,
  ],
  exports: [
    FlexLayoutModule,
    DataTableFilterComponent,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    ChartsModule,
    MaterialModule,
    FileInput,
    AgmCoreModule,
    dewMatPager,
    MustMatchDirective,
    UsernameUniqueDirective,
    EmailUniqueDirective,
    SubDomainUniqueDirective,
    HasPermission,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    PdfViewerModule,
    CarouselModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    dewVideoPlayer,
  ],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
  ],
  entryComponents: [
    EditApplicationUserDialog,
    DeleteConfirmDialogComponent,
    DewConfirmDialogComponent,
    DewAlertDialogComponent,
    AddApplicationUserDialog,
    AddApplicationUserRolesDialog,
    AddApplicationRoleDialog,
    ChangePasswordDialog,
    EditApplicationEntityDialog,
    AddApplicationEntityDialog,
    EditApplicationOperationsDialog,
    AddApplicationOperationsDialog,
    AddApplicationRoleDialog,
    RoleAddEntityOperationDialog,
    EditApplicationRoleDialog,
    AddCodeTableDialog,
    EditCodeTableDialog,
    AddCodeTableHeaderDialog,
    AddDocumentDialog,
    EditDocumentDialog,
    AddApplicationRoleAndTaskDialog,
    EditApplicationRoleAndTaskDialog,
    RoleAndTaskAddEntityOperationDialog,
  ],
})
export class SharedModule {}
